import { DEFAULT_SORT, DEFAULT_PAGINATION } from './constants.js';

export default {
  //Основные данные
  data: {},
  map: [],
  next: DEFAULT_PAGINATION.next,
  
  //UI состояния
  isLoading: false,
  isReady: false,
  isLoadingNext: false,
  
  //Фильтры и сортировка
  activeFilter: null,
  activeSort: { ...DEFAULT_SORT },
  searchQuery: '',
  
  //Избранное (оптимистичные обновления)
  optimisticOriginal: {},
  debounceTimers: {},
  
  //Последние сигналы
  lastSignals: [],
  isLoadingLastSignals: false,
  readyLastSignals: false,
  
  //Редактирование и черновики
  draftForm: {},
  idEditSignal: null,
  isSignalSendLoading: false
};